import { IBaseComponentProps, NSBox, NSBoxCombo, NSInfoProps, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";

export interface ConditionClassifierClassLineProps extends IBaseComponentProps
{
    index: number;
    title: string;
    deletable: boolean;
    onDelete: () => void;
    onChanged?: (value: string | null) => void;
    getOptions: () => { value: string; title: string; }[];
    info?: NSInfoProps;
}

export default class ConditionClassifierClassLine extends Component<ConditionClassifierClassLineProps>
{
    static IS_DIRTY(value: string | null): boolean
    {
        return !!(value && value.trim().length > 0);
    }

    private NSBoxCombo_Value = createRef<NSBoxCombo>();

    constructor(props: ConditionClassifierClassLineProps)
    {
        super(props);
        this.getValue = this.getValue.bind(this);
        this.setValue = this.setValue.bind(this);
        this.isDirty = this.isDirty.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    getValue(checkError: boolean = false): string | null
    {
        let value = this.NSBoxCombo_Value.current?.getValueOne(checkError) ?? null;
        if (!value || !value.trim())
            return null;
        return value.trim();
    }

    setValue(value: string)
    {
        this.NSBoxCombo_Value.current?.setValueOne(value);
    }

    isDirty(): boolean
    {
        return ConditionClassifierClassLine.IS_DIRTY(this.getValue(false));
    }

    private onChanged()
    {
        if (this.props.onChanged)
            this.props.onChanged(this.getValue(false));
    }

    override render()
    {
        return (
            <NSRow style={{ ...this.props.style, flexWrap: "nowrap" }}>
                <NSBoxCombo
                    ref={this.NSBoxCombo_Value}
                    title={`${this.props.title} ${this.props.index + 1}`}
                    required
                    multiple={false}
                    info={this.props.info}
                    getOptions={this.props.getOptions}
                    onChanged={this.onChanged}
                    menu={{
                        builtin: {
                            delete: {
                                enabled: this.props.deletable,
                                onDelete: this.props.onDelete
                            }
                        },
                        items: []
                    }}
                    style={{ width: NSBox.width.double }}
                />
            </NSRow>
        );
    }
}